import React, { ReactElement } from 'react'
import styled from 'styled-components'
import {themes} from './theme'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp , library, SizeProp} from '@fortawesome/fontawesome-svg-core'
import { faSpotify, faSoundcloud, faInstagram, faFacebook, faGithub} from '@fortawesome/free-brands-svg-icons'

library.add(faSpotify, faSoundcloud, faFacebook, faInstagram, faGithub )
const StyledIcon = styled.a<{ main: boolean }>`
    display:grid;
    position:relative;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
    color: ${(props) => props.main ? themes.primary.main : themes.secondary.main};
    &:hover {
        color: ${(props) => props.main ? themes.primary.sub : themes.secondary.sub};
    }
`

interface IconProps {
    onClick? : () => void
    main: boolean;
    value: IconProp;
    size: SizeProp;
    href?: string;
}

const IconButton = ({ onClick, main, value, size, href }:IconProps) : ReactElement => {
    return (
        <StyledIcon href={href} onClick={onClick} main={main} >
            <FontAwesomeIcon size={size} icon={value}/>
        </StyledIcon>
    )
}

export {IconButton}